import styled from "styled-components";
import { themevals as theme } from "theme/themevals";

export const ModalSubtitle = styled.div`
    font-size: 12px;
    color: ${theme.colors.dkgrey};
    font-family:"Poppins";
    font-weight:500;
`

export const ModalTitle = styled.div`
    font-size: 16px;
    font-weight: 500;
    font-family: "Rubik";
    color: ${theme.colors.base_800};
    margin-bottom:10px;
`

export const ModalIcon = styled.div`
    width:18px;
    height:18px;
    svg{
    fill:black !important;}
    display:flex;
    margin-right:10px;
`

export const ModalTitleWrapper = styled.div` 
display:flex;   
flex-direction:column;
margin-bottom:10px;
`

export const EllipsisWrapper = styled.div`
    display:flex;
`

export const InviteWrapper = styled.div`
    display:flex;
    flex-direction:row;
    cursor:pointer;
`

export const InviteText = styled.div`
    flex: 1 1 auto;
    white-space: nowrap;
`

export const InviteIconWrapper = styled.div`
    flex: 0 0 auto;
    margin-left:10px;
    display:flex;
    align-items:center;
`